import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone:false
})
export class AuthComponent implements OnInit{
  ngOnInit(): void {
  }

}
